// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"60e160d3","977":"5fb0ddf7"}[chunkId] + ".chunk.js";
};